import { render, staticRenderFns } from "./TableContactProjects.vue?vue&type=template&id=3b313a6e&"
import script from "./TableContactProjects.vue?vue&type=script&lang=js&"
export * from "./TableContactProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports